import { createAppSlice } from '../createAppSlice'

interface InitialState {
  submitted: boolean
}

const initialState: InitialState = {
  submitted: false,
}

export const ticketSlice = createAppSlice({
  initialState,
  name: 'tickets',
  reducers: (create) => ({
    setSubmitted: create.reducer<boolean>((state, action) => {
      state.submitted = action.payload
    }),
  }),
  selectors: {
    submitted: (state) => state.submitted,
  },
})
